import { SunAngleOutlineIcon } from './SunAngleOutlineIcon';

/**
 * author: Michael Irigoyen
 * id EFBF30D4-A767-490C-883D-9C94E0789C0D
 * name sun-angle-outline
 * version: 6.9.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sun-angle-outline.svg
 * tags
 * - Weather 
 */
export const SolarAngleOutlineIcon = SunAngleOutlineIcon;
export default SolarAngleOutlineIcon